import { render, staticRenderFns } from "./parallaxScrollingFlip.vue?vue&type=template&id=8a4ddcd8&"
import script from "./parallaxScrollingFlip.vue?vue&type=script&lang=js&"
export * from "./parallaxScrollingFlip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports